"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.COMPONENT_NAME = void 0;
var _react = _interopRequireDefault(require("react"));
var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));
var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.button"));
var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));
var _gerenciatdUnifiedcomponents4 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.image"));
var _gerenciatdUtils = require("@bit/gerenciatd.utils.style-utils");
var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.common");
require("./ClickBox.scss");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const COMPONENT_NAME = 'ClickBox';
exports.COMPONENT_NAME = COMPONENT_NAME;
const ClickBox = props => {
  const {
    components
  } = props;
  let {
    taggingInfo
  } = props;
  if (!taggingInfo) {
    taggingInfo = {
      componentVariation: 'all',
      componentName: COMPONENT_NAME,
      componentProduct: ''
    };
  }
  const ClickBoxId = (0, _gerenciatdUtils2.generateComponentId)('ClickBox', 'clickbox');
  const generateBgAndProperties = (idBanner, components, layout) => {
    // Tratamiento fondo del banner
    let whereDiv2Fit = '';
    let cssbgColor = '';
    if (components && components['BgImage-1']) {
      const currentBGImg = components['BgImage-1'];
      cssbgColor = `--${currentBGImg.bgColor}`;
      whereDiv2Fit = currentBGImg.div2Fit;
      (0, _gerenciatdUtils.bannerBuildBGImg)(currentBGImg, idBanner, currentBGImg.div2Fit, currentBGImg.bgColor, layout);
    }
    return {
      whereDiv2Fit,
      cssbgColor
    };
  };
  generateBgAndProperties(ClickBoxId, components);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
    className: "ClickBoxSection",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "ClickBoxContainer container",
      children: [components['BgImage-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "mobilePhoto",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents4.default, {
          src: components['BgImage-1'].picMobile.src,
          alt: components['BgImage-1'].picMobile.alt
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "ClickBox",
        id: ClickBoxId,
        children: [components.title && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({}, components.title)), components.descripcion && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "ClickBox__subtitle",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({}, components.descripcion))
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "ClickBox__button",
          children: components.button && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, components.button), {}, {
            taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
              componentContent: components.button.label
            })
          }))
        })]
      })]
    }), components.button && components.button.label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
      isBlockElement: true,
      link: components.button.link,
      target: "_blank",
      forceExternal: true,
      taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
        componentContent: components.button.label
      })
    })]
  });
};
var _default = ClickBox;
exports.default = _default;

//# sourceMappingURL=index.js.map